<template>
  <button :class="type" :disabled="disabled" @click="callback($event)">
    <i :class="right_icon"></i>
    <slot/>
    <i :class="left_icon"></i>
  </button>
</template>

<script>

export default {
  name: 'lte-label',
  props: ['type', 'left_icon', 'right_icon', 'disabled'],
  methods: {
    callback: function (e) {
      this.$emit('click', e)
    }
  }
}

</script>

<style lang="scss" scoped>
  button {
    // padding: 5px 5px;
    font-size: 14px;
    font-family: arail;
    cursor: pointer;
    margin: 1px;
    &[disabled]{
      cursor: not-allowed;
    }
    &.danger {
      // padding: 5px 20px;
      border: 1px solid #ddd;
      color: #333;
      background-color:#fff;
      border-radius: 4px;
      background-color: #ff4949;
      color: #fff;
      margin: 1px;
    }
    &.danger_black {
      // padding: 5px 20px;
      border: 1px solid #ddd;
      color: #333;
      background-color:#fff;
      border-radius: 4px;
      background-color: #ff4949;
      color: #000;
      margin: 1px;
    }
    &.success {
      // padding: 5px 20px;
      border: 1px solid #ddd;
      color: #333;
      background-color:#fff;
      border-radius: 4px;
      background-color: #13ce66;
      color: #fff;
      margin: 1px;
    }
    &.info {
      // padding: 5px 20px;
      border: 1px solid #ddd;
      color: #333;
      background-color:#fff;
      border-radius: 4px;
      background-color: #50bfff;
      color: #fff;
      margin: 1px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LTEButton.vue